<template>
  <div id="video_live" class="relativeItem">
    <!--直播间区域-->
    <div class="live relativeItem" :class="{ living: ready }">
      <!--封面-->
      <img
        :src="info.showcover"
        class="cover imgBlock noevents-img filter_cover"
        v-if="!is_star"
      />

      <!--ios中用这个-->
      <video-player
        class="video-player vjs-custom-skin cover"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
        @play="onPlayerPlay"
        v-if="is_star && !in_Android"
      ></video-player>

      <!--安卓中用这个-->
      <video-player
        class="video-player vjs-custom-skin cover"
        ref="videoPlayer"
        :options="playerOptions"
        @play="onPlayerPlay"
        @canplay="onPlayerCanplay"
        v-else-if="is_star"
      ></video-player>

      <!--聊天信息-->
      <zhibochat
        class="chat"
        v-if="show_chat"
        @up_heat="upheat"
        @uppoint="uppoint"
        @end="end_palying"
      ></zhibochat>

      <!--头像和榜单-->
      <div class="top flex-box absoluteItem" v-show="!is_over">
        <!--头像区域-->
        <div class="head flex-box relativeItem">
          <a class="allA" id="live-download1"></a>
          <div class="img">
            <img :src="info.avatar" class="mlz-img imgBlock noevents-img" />
          </div>
          <div class="text">
            <p class="p1 apostrophe">{{ info.nickname }}</p>
            <p class="p2">{{ info.heat }}热度</p>
          </div>
          <img
            src="../../assets/share/video_shere(6).png"
            class="gz imgBlock noevents-img"
          />
        </div>

        <!--榜单区域-->
        <div class="list-shell relativeItem">
          <a class="allA" id="live-download2"></a>
          <ul class="flex-box">
            <li
              class="relativeItem"
              v-for="(n, index) in wathcer"
              :key="index"
              v-show="index < 4"
            >
              <img
                src="../../assets/share/live_share(4).png"
                class="head-shell imgBlock absoluteItem"
                v-if="index < 3"
              />

              <img :src="n.avatar" class="avatar imgBlock noevents-img" />
              <span class="imgBlock absoluteItem centerX">{{ n.honor }}</span>
            </li>

            <!--虚化层-->
            <!-- <span class="xuhua absoluteItem centerY"></span> -->
          </ul>

          <!--最右侧按钮-->
          <img
            src="../../assets/share/live_share(8).png"
            class="moer-list imgBlock noevents-img absoluteItem centerY"
          />
        </div>
      </div>

      <!--魅力值和朱贝号-->
      <div class="mlz_n absoluteItem flex-box" v-show="!is_over">
        <div class="mlz flex-box relativeItem">
          <img
            src="../../assets/share/live_share(5).png"
            class="sign imgBlock noevents-img absoluteItem centerY"
          />
          <img
            src="../../assets/share/live_share(7).png"
            class="mlz-img imgBlock noevents-img"
          />
          {{ info.totalpoint }}
          <img
            src="../../assets/share/live_share.png"
            class="arrow absoluteItem centerY imgBlock noevents-img"
          />
        </div>
        <div class="zbh flex-box">
          <img src="../../assets/share/live_share(9).png" class="noevents-img" />&nbsp;{{
            info.roomnumber
          }}
        </div>
      </div>

      <!--底部按钮-->
      <div class="b-bottom absoluteItem centerX" v-show="!is_over">
        <a id="live-download3" class="allA"></a>
        <img src="../../assets/share/live_share(3).png" class="img1 noevents-img" />
        <img src="../../assets/share/live_share(6).png" class="img2 noevents-img" />
        <img src="../../assets/share/live_share(1).png" class="img3 noevents-img" />
      </div>
    </div>

    <!--直播结束区域-->
    <div class="over absoluteItem" v-show="is_over">
      <p class="p1">本场直播已结束</p>
      <p class="p2">
        <img :src="info.avatar" class="imgBlock noevents-img" />
      </p>
      <p class="p3">{{ info.nickname }}</p>
      <p class="p4">朱贝号{{ info.roomnumber }}</p>
      <div class="btn">
        <img src="../../assets/share/live_share(2).png" class="imgBlock noevents-img" />
      </div>
    </div>
  </div>
</template>

<script>
import zhibochat from "../index/zhibochat_share";

import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";

// videojs
import videojs from "video.js";
window.videojs = videojs;

// hls plugin for videojs6
require("videojs-contrib-hls/dist/videojs-contrib-hls.js");

export default {
  name: "video_live",
  components: { zhibochat },
  data() {
    return {
      in_Android: false, //判断是否在安卓
      show_chat: false, //是否显示聊天框
      ready: false, //播放地址是否准备完毕
      is_star: false, //判断用户是否点击了播放
      is_over: false, //判断视频是否播放结束
      info: { avater: "", showcover: "", nickname: "", roomnumber: "" }, //主播信息
      liveUrl: "", //直播流地址
      wathcer: [], //观众席
      playerOptions: {
        autoplay: false, //如果true,浏览器准备好时开始回放。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        sources: [
          {
            type: "application/x-mpegURL", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "", //url地址
          },
        ],
        poster: "", //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: false,
        flash: { hls: { withCredentials: false } },
        html5: { hls: { withCredentials: false } },
      },
    };
  },
  methods: {
    /**openinstall相关事务 */
    open_install_thing() {
      /*web页面向app传递的json数据(json string/js Object)，应用被拉起或是首次安装时，通过相应的android/ios api可以获取此数据*/
      // eslint-disable-next-line
      var data = OpenInstall.parseUrlParams(); //openinstall.js中提供的工具函数，解析url中的所有查询参数
      // eslint-disable-next-line
      new OpenInstall(
        {
          /*appKey必选参数，openinstall平台为每个应用分配的ID*/
          appKey: "tj3x4l",
          /*openinstall初始化完成的回调函数，可选*/
          onready: function () {
            var m = this,
              button1 = document.getElementById("live-download1"),
              button2 = document.getElementById("live-download2"),
              button3 = document.getElementById("live-download3");
            /*在app已安装的情况尝试拉起app*/
            m.schemeWakeup();
            /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
            button1.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
            button2.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
            button3.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
          },
        },
        data
      );
    },

    //播放视频
    play() {
      this.is_star = true;
    },

    onPlayerCanplay() {
      var ua = navigator.userAgent.toLocaleLowerCase();
      if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
        // x5内核
        let video = document.getElementsByTagName("video")[0];
        video.setAttribute("x5-video-player-type", "h5"); // 声明启用同层H5播放器，控制网页内部同层播放，可以在视频上方显示html元素。
        video.setAttribute("x5-video-orientation", "landscape|portrait"); // 播放器支持的方向--跟随手机自动旋转，此属性只在声明了x5-video-player-type=”h5”情况下生效
        video.setAttribute("x5-video-player-fullscreen", "true"); // 进入全屏通知
      } else {
        // ios端
        let video = document.getElementsByTagName("video")[0];
        video.setAttribute("webkit-playsinline", "true"); //设置ios在微信中内联播放视频 ios9
        video.setAttribute("playsinline", "true"); //设置ios在微信中内联播放视频 ios10/ios11
      }
    },

    /**视频开始播放时 */
    onPlayerPlay() {
      this.ready = true;
      this.show_chat = true;
    },

    //更新热度
    upheat(e) {
      this.info.heat = this.$tool.million(e);
    },

    //更新魅力值
    uppoint(e) {
      this.info.totalpoint = e;
    },

    //直播结束
    end_palying() {
      this.ready = false;
      this.is_star = false;
      this.show_chat = false;
      this.is_over = true;
    },

    /**获取观众席 */
    get_watcher() {
      let _this = this;
      let data = {
        pagesize: 4,
        page: 1,
      };
      this.$jsonp(this.$apis("live_share_watcher"), data, (res) => {
        _this.wathcer = res.data.data.list;
        _this.wathcer.forEach((e) => {
          e.honor = _this.$tool.million(e.honor, "cn");
        });
      });
    },

    /**获取直主播的信息 */
    /**处理播放数据 */
    videoSource() {
      let _this = this;
      let data = {
        type:0
      };
      if (this.$route.query.roomnumber) {
        data.roomnumber = this.$route.query.roomnumber;
      } else {
        //跳到分享页
        this.$router.push({ path: "/share" });
        return;
      }
      this.$jsonp(this.$apis("liveUrl"), data, (res) => {
        _this.info = res.data.data.result;
        if (res.data.data.result.is_showing == "0") {
          //已经结束
          _this.is_over = true;
        } else {
          _this.is_star = true;
          //正在直播
          _this.info.heat = _this.$tool.million(_this.info.heat);
          _this.playerOptions.sources[0].src = res.data.data.result.url;
          _this.playerOptions.poster = _this.info.showcover;
          // _this.ready = true;
          _this.$tool.setTitle(_this.info.nickname + "正在朱贝直播");
        }
      });
    },
  },
  computed: {
    palyer() {
      return this.$refs.videoPlayer.palyer;
    },
  },
  mounted: function () {
    /**判断是否在安卓 */
    var u = navigator.userAgent;
    this.in_Android = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
    this.videoSource();
    this.get_watcher();
    let _this = this;
    setTimeout(() => {
      _this.open_install_thing();
    }, 1000);
  },
};
</script>

<style scoped>
#video_live {
  z-index: 10;
}
/**直播区域 */
.cover {
  height: 100%;
}
.filter_cover {
  filter: blur(0.4rem);
}
.live {
  height: 350px;
}
.living {
  height: calc(100vh - 70px);
}

/**头像和榜单 */
.top {
  width: 100%;
  top: 0;
  padding: 8px;
  justify-content: space-between;
  z-index: 3;
}
.top .head {
  align-items: center;
  border-radius: 3rem;
  background: rgba(0, 0, 0, 0.3);
  padding-right: 4px;
}
.top .head .img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 8px;
}
.top .img img {
  width: 100%;
  height: 100%;
}
.top .head .p1 {
  max-width: 80px;
  font-size: 12px;
  color: #fff;
}
.top .head .p2 {
  font-size: 9px;
  color: #d4d4d3;
  font-family: kefu;
}
.top .head .gz {
  width: 36px;
  height: 22px;
  margin-left: 10px;
}
/**榜单区域 */
.list-shell {
  max-width: 56%;
  word-break: keep-all;
  white-space: nowrap;
  padding-right: 25px;
}
.list-shell .allA {
  z-index: 5;
}
ul li {
  width: 30px;
  height: 30px;
  margin-right: 6px;
  border-radius: 50%;
}
ul li .head {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
ul li .avatar {
  border-radius: 50%;
}
ul li .head-shell {
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1;
}
ul li span {
  width: 100%;
  text-align: center;
  font-size: 8px;
  color: #fff;
  border-radius: 3rem;
  background: rgba(0, 0, 0, 0.3);
  bottom: 0;
  z-index: 2;
}
ul li:nth-child(1) span {
  background: rgba(252, 176, 64, 0.8);
}
ul li:nth-child(2) span {
  background: rgba(255, 255, 255, 0.8);
}
ul li:nth-child(3) span {
  background: rgba(251, 136, 98, 0.8);
}
.moer-list {
  width: 30px;
  height: 30px;
  right: 0;
  z-index: 4;
}
ul .xuhua {
  width: 25px;
  right: 0;
  background: linear-gradient(to right, rgba(255, 255, 255));
}

/**魅力值 */
.mlz_n {
  padding: 0 8px;
  padding-left: 15px;
  justify-content: space-between;
  top: 50px;
  left: 0;
  width: 100%;
  z-index: 3;
}
.mlz {
  width: auto;
  align-items: center;
  font-size: 10px;
  border-radius: 3rem;
  border: 1px solid #ff67d1;
  padding: 1px;
  color: #fff;
  padding-right: 20px;
  background: rgba(0, 0, 0, 0.4);
}
.mlz .sign {
  width: 19px;
  left: -7px;
}
.mlz .mlz-img {
  width: 52px;
  height: 14px;
  margin-right: 3px;
}
.mlz .arrow {
  width: 6px;
  height: 6px;
  right: 4px;
}
.zbh * {
  vertical-align: middle;
}
.zbh {
  font-size: 13px;
  color: #d4d4d3;
  font-family: kefu;
  align-items: center;
}
.zbh img {
  width: 33px;
  height: 13px;
  display: block;
}

/**底部按钮 */
.b-bottom {
  width: 100%;
  bottom: 8px;
  padding: 0 8px;
  z-index: 3;
}
.b-bottom,
.b-bottom div {
  justify-content: space-between;
  align-items: center;
}
.b-bottom img {
  float: left;
}
.b-bottom .img1 {
  width: 41%;
  margin-right: 6px;
}
.b-bottom .img2 {
  width: 9%;
  float: left;
}
.b-bottom .img3 {
  width: 34%;
  float: right;
}

/**结束区域 */
.over {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10;
}
.over p {
  text-align: center;
}
.over .p1 {
  font-size: 20px;
  font-weight: bold;
  color: #d4d4d3;
  margin-top: 72px;
  margin-bottom: 26px;
}
.over .p2 {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
  margin-bottom: 8px;
}
.over .p2 img {
  width: 100%;
  height: 100%;
}
.over .p3 {
  font-size: 15px;
  color: #fff;
  margin-bottom: 4px;
}
.over .p4 {
  font-size: 12px;
  color: #d4d4d3;
  margin-bottom: 28px;
}
.over .btn {
  width: 41%;
  margin: 0 auto;
}
.over .btn img {
  width: 100%;
}

/**播放按钮 */
.play_btn {
  width: 60px;
  z-index: 2;
}

/**视频区域 */
/**视频区域 */
.video-js .vjs-icon-placeholder {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
<style>
.video-js {
  height: 100%;
}
.video-js .vjs-tech {
  object-fit: fill;
}
.vjs-poster {
  background-size: cover;
}
.vjs-custom-skin > .video-js .vjs-big-play-button {
  height: 1.5em !important;
  width: 1.5em;
  line-height: 1.5 !important;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(14%);
  margin-left: 0;
}
</style>
